import React from 'react';
import { ActivityAssociation, TableName } from 'v2/models';
import {
  ActivityItemLinkCreatedDataVendor,
  ActivityItemLinkCreatedDataProduct,
  ActivityItemLinkCreatedContact,
} from './components';

type ActivityItemLinkCreatedProps = {
  associations: ActivityAssociation[];
};

export function ActivityItemLinkCreated({
  associations,
}: ActivityItemLinkCreatedProps) {
  const entityAssociation = associations.find(
    (association) => association.table_name !== TableName.Searches
  );
  const searchAssociation = associations.find(
    (association) => association.table_name === TableName.Searches
  );

  if (entityAssociation === undefined || searchAssociation === undefined) {
    return null;
  }

  switch (entityAssociation.table_name) {
    case TableName.DataVendor:
      return (
        <ActivityItemLinkCreatedDataVendor
          objectID={entityAssociation.object_id}
          searchID={searchAssociation.object_id}
        />
      );

    case TableName.DataProduct:
      return (
        <ActivityItemLinkCreatedDataProduct
          objectID={entityAssociation.object_id}
          searchID={searchAssociation.object_id}
        />
      );

    case TableName.Contact:
      return (
        <ActivityItemLinkCreatedContact
          objectID={entityAssociation.object_id}
          searchID={searchAssociation.object_id}
        />
      );

    default:
      return null;
  }
}
